export const RESTAURANT_NOTIFICATION_TYPES = {
  itemsRequested: "restaurant.items.requested",
  paymentSubmitted: "restaurant.payment.submitted",
  kitchenTicketsCreated: "restaurant.kitchen.tickets.created",
  itemsReady: "restaurant.items.ready",
  /** D151 — the owner's nightly number, sent when the last drawer closes. */
  dayClosed: "restaurant.day.closed",
  /**
   * D156 — told to the APPROVER alone: their password approved an exception
   * act at another session's till.
   */
  approvalUsed: "restaurant.approval.used",
  /**
   * 2026-10-20 — a customer's takeaway/delivery request from the storefront,
   * waiting on the till's accept or reject.
   */
  onlineOrderRequested: "restaurant.online-order.requested",
} as const;

export type RestaurantNotificationType =
  (typeof RESTAURANT_NOTIFICATION_TYPES)[keyof typeof RESTAURANT_NOTIFICATION_TYPES];

const ALL_TYPES = new Set<string>(Object.values(RESTAURANT_NOTIFICATION_TYPES));
const PERSISTED_TYPES = new Set<string>([
  RESTAURANT_NOTIFICATION_TYPES.itemsRequested,
  RESTAURANT_NOTIFICATION_TYPES.paymentSubmitted,
  RESTAURANT_NOTIFICATION_TYPES.dayClosed,
  RESTAURANT_NOTIFICATION_TYPES.approvalUsed,
  RESTAURANT_NOTIFICATION_TYPES.onlineOrderRequested,
]);

/**
 * Only the seven restaurant worker events may reach foreground/background UI —
 * the four operational ones, a storefront takeaway/delivery request, the
 * owner's nightly number (D151) and the approver's notice (D156).
 */
export function isRestaurantNotificationType(
  value: unknown,
): value is RestaurantNotificationType {
  return typeof value === "string" && ALL_TYPES.has(value);
}

/**
 * Guest requests (table and online), payment claims, the nightly number and the
 * approver's notice belong in the Firestore bell feed — the last two so a push swiped away can
 * be read again.
 */
export function isRestaurantPersistentNotificationType(
  value: unknown,
): value is RestaurantNotificationType {
  return typeof value === "string" && PERSISTED_TYPES.has(value);
}
